import {Injectable} from '@angular/core';
import {AuthenticationService} from "projects/nter-ui-kit/src/lib/framework/security/service/authentication.service";
import {HttpClient} from "@angular/common/http";
import {UserService} from "projects/nter-ui-kit/src/lib/framework/security/service/user.service";
import {NavigationUtilsService} from "projects/nter-ui-kit/src/lib/framework/util/service/navigation-utils.service";
import {AppConfigService} from "projects/nter-ui-kit/src/lib/framework/config/app-config.service";
import {ConsoleContextService} from "projects/soko-console-web-v2/src/app/security/console-context.service";

@Injectable({
  providedIn: 'root'
})
export class ConsoleAuthenticationService extends AuthenticationService {

  constructor(
    http: HttpClient,
    protected override contextService: ConsoleContextService,
    userService: UserService,
    utilsService: NavigationUtilsService,
    config: AppConfigService
  ) {
    super(http, contextService, userService, utilsService, config);
  }

  public override logout(): void;
  public override logout(issueRedirect: boolean): void;
  public override logout(issueRedirect: boolean, clientId: string | null, queryParams: any): void;
  public override logout(issueRedirect: boolean = true, clientId? : string | null, queryParams?: any): void {
    clientId = clientId ?? this.contextService.getCurrentLandlordCode();
    super.logout(false);
    if (issueRedirect) {
      const uri = clientId ? `${clientId}/login` : '404';
      const message =  clientId ?  "Please login to continue" : null;
      this.utilsService.navigateWithQueryParams(uri, message, queryParams);
    }
  }
}
